"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 640,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_c("form", {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n          Atribuir Escala a Funcionário\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("b-field", {
    attrs: {
      label: "Funcionário"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione um funcionário",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.userId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userId", $$v);
      },
      expression: "form.userId"
    }
  }, _vm._l(_vm.users, function (user) {
    return _c("option", {
      key: user.id,
      domProps: {
        value: user.id
      }
    }, [_vm._v("\n              " + _vm._s(user.firstName) + " " + _vm._s(user.lastName) + "\n            ")]);
  }), 0)], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Escala de horário"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione uma escala",
      required: "",
      expanded: ""
    },
    model: {
      value: _vm.form.shiftHoursId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "shiftHoursId", $$v);
      },
      expression: "form.shiftHoursId"
    }
  }, _vm._l(_vm.shiftHours, function (shift) {
    return _c("option", {
      key: shift.id,
      domProps: {
        value: shift.id
      }
    }, [_vm._v("\n              " + _vm._s(shift.title) + "\n            ")]);
  }), 0)], 1)], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      "native-type": "submit",
      loading: _vm.isLoading
    }
  }, [_vm._v("\n          Salvar\n        ")]), _vm._v(" "), _c("b-button", {
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;